// @ts-nocheck
import React, { useCallback, useEffect, useMemo } from 'react'

import CheckOutlined from '@ant-design/icons/lib/icons/CheckOutlined'
import DeleteOutlined from '@ant-design/icons/lib/icons/DeleteOutlined'
import EditOutlined from '@ant-design/icons/lib/icons/EditOutlined'
import MoreOutlined from '@ant-design/icons/lib/icons/MoreOutlined'
import QuestionCircleOutlined from '@ant-design/icons/lib/icons/QuestionCircleOutlined'
import StopOutlined from '@ant-design/icons/lib/icons/StopOutlined'
import {
  Dropdown,
  Menu,
  Modal,
  Empty,
  message,
  Button,
  Row,
  Col,
  Tabs,
} from 'antd'
import { inject, observer } from 'mobx-react'
import moment from 'moment'
import { useState } from 'react'
import { Helmet } from 'react-helmet/es/Helmet'
import { blue, green, purple9, redPrimary } from '../../../color'
import { EmptyText, TitleContentBox } from '../../../components/Common/CellText'
import { SelectList } from '../../../pages/MissionCreatePage/MissionCreatePageStyled'
import FileItem from '../../../components/Common/FileItemComponent/FileItem'
import { StatusTag } from '../../../components/Common/StatusTag'
import ContentBlockWrapper from '../../../components/ContentBlockWrapper'
import PageTitle from '../../../components/PageTitle'
import AppPageHeader from '../../../components/AppPageHeader'
import PopoverWatchTime from '../../../components/PopoverWatchTime'
import SpinnerInlineComponent from '../../../components/SpinnerInlineComponent'
import {
  ACL_ACTION_TYPE,
  DATE_FORMAT_DEFAULT,
  PROPOSAL_STATUS,
  PROPOSAL_TYPE,
  TYPE_STATUS,
  SHIFTS,
  MODES,
} from '../../../constants'
import TableComponent from '../../../components/Common/TableComponent'
import DashboardLayout from '../../../layouts/DashboardLayout'
import { DocumentInfoList } from '../../../layouts/ThongTinChungLayout/ThongTinChungLayoutStyled'
import loadingAnimationStore from '../../../stores/loadingAnimationStore'
import utils from '../../../utils'
import { HeadingButtonWrapper } from '../../MissionDetailPage/MissionDetailPageStyled'
import DistributionVotesAction from './DistributionVotesAction'
import {
  BlockLeft,
  BlockRight,
  ContentWrapper,
  ViewDetailContent,
} from './DistributionVotesDetailStyle'
import DistributionVotesComment from './DistributionVotesComment'
import DistributionVotesUpdate from '../DistributionVotesUpdate'
import { toJS } from 'mobx'
import ManagementAssetWarehouseRequest from '../../../requests/ManagementAssetWarehouseRequest'
import AccessControlAction from '../../../components/AccessControlAction'
import {
  ArrowLeftBroken,
  ForbiddenCircleOutlineIcon,
  MenuDotsBoldIcon,
  PenOutlineIcon,
  TrashBin2OutlineIcon,
  UnreadOutlineIcon,
} from '../../../components/AppIcon'
import { KeyValueItem } from '../../../components/Common/KeyValueItem'
import { AppTable } from '../../../components/AppTable/AppTable'

const { confirm } = Modal

const DistributionVotesDetailPage = props => {
  const {
    proposalStore,
    match,
    history,
    notificationStore,
    aclStore,
    commonStore,
    authenticationStore,
    proposalTypeStore,
    DistributionVotesStore,
    managementAssetWarehouseStore,
    loadingAnimationStore,
    selectPeopleStore,
    assetTypeId = null,
  } = props
  const { proposalId, typePage } = match.params
  const { otherDetail } = proposalStore
  const {
    distributionVotesDetail,
    distributionVotesDetails,
  } = DistributionVotesStore
  const {
    managementAssetWarehouseLists,
    managementAssetWarehouseAllLists,
    managementAssetWarehouseDetail,
  } = managementAssetWarehouseStore

  const [selectedData, setSelectedData] = useState([])
  // Không xóa dòng khai báo aclActionsByUser (dù k dùng)
  const { aclActionsByUser } = aclStore
  const [isVisibleUpdateModal, setIsVisibleUpdateModal] = useState(false)
  const [
    isVisibleUpdateFollowersModalModal,
    setIsVisibleUpdateFollowersModalModal,
  ] = useState(false)
  const { isAccountAdmin } = authenticationStore
  const [listDataHistory, setListDataHistory] = useState([])

  // Lấy thông tin văn phòng phẩm
  useEffect(() => {
    const fetchData = async () => {
      let listItem = []
      if (distributionVotesDetails?.proposal_asset_details) {
        for (let item of distributionVotesDetails.proposal_asset_details) {
          try {
            const response = await ManagementAssetWarehouseRequest.getManagementAssetWarehouseDetail(
              item.asset_id
            )
            const { id, tax, price, total_money } = response.data
            listItem.push({ id, tax, price, total_money })
          } catch (error) {
            console.error('Error fetching data:', error)
          }
        }
      }
      const combinedData = distributionVotesDetails.proposal_asset_details.map(
        proposalDetail => {
          const matchingItem = listItem.find(
            item => item.id === proposalDetail.asset_id
          )
          return {
            ...proposalDetail,
            ...(matchingItem
              ? {
                  tax: matchingItem.tax,
                  price: matchingItem.price,
                  total_money: matchingItem.total_money,
                }
              : {}),
          }
        }
      )
      setListDataHistory(combinedData)
    }

    fetchData()
  }, [distributionVotesDetails])

  const handleApprovalProposal = async data => {
    loadingAnimationStore.showSpinner(true)
    try {
      await DistributionVotesStore.DistributionVotesOther(data)
      await DistributionVotesStore.getDistributionVotesDetail(proposalId)
      await DistributionVotesStore.getDistributionVotesComment(proposalId)
      if (data.type === PROPOSAL_STATUS.REJECT) {
        return message.success('Hủy thành công!')
      }
      // window.location.reload();
      return message.success('Duyệt thành công!')
    } catch (e) {
      if (data.type === PROPOSAL_STATUS.REJECT) {
        return message.error('Hủy thất bại!')
      }
      return message.error('Duyệt thất bại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  // create function GetDiffAssets từ đoạn code dưới đây
  const isAllAssetSelected = () => {
    const selectedAssetCount = managementAssetWarehouseAllLists?.filter(item =>
      distributionVotesDetails?.proposal_asset_details.some(
        dataItem => dataItem.asset_id === item.id
      )
    ).length

    const availableAssetCount = managementAssetWarehouseLists?.filter(item =>
      distributionVotesDetail?.proposal_asset_details.some(
        dataItem => dataItem.asset_id === item.id
      )
    ).length

    return selectedAssetCount === availableAssetCount ? true : false
  }

  const getDiffAssets = () => {
    const selectedAssetCount = managementAssetWarehouseAllLists
      ?.filter(item =>
        distributionVotesDetails?.proposal_asset_details.some(
          dataItem => dataItem.asset_id === item.id
        )
      )
      .map(item => item)

    const availableAssetCount = managementAssetWarehouseLists
      ?.filter(item =>
        distributionVotesDetail?.proposal_asset_details.some(
          dataItem => dataItem.asset_id === item.id
        )
      )
      .map(item => item)

    const diff = selectedAssetCount.filter(
      item => !availableAssetCount.some(dataItem => dataItem.id === item.id)
    )

    return JSON.stringify(diff)
  }

  useEffect(() => {
    ;(async () => {
      await DistributionVotesStore.clearFilterProposal()
      await managementAssetWarehouseStore.getManagementAssetWarehousetLists()
      await managementAssetWarehouseStore.getManagementAssetWarehouseAllList()
      await selectPeopleStore.getDepartmentWithUsersV2()
    })()
  }, [])

  const handleDeleteProposal = async () => {
    try {
      loadingAnimationStore.showSpinner(true)
      await DistributionVotesStore.delete(proposalId)
      history.push('/distribution-votes')
      message.success('Xóa thành công!')
    } catch (err) {
      console.log(err)
      message.error(err.vi || 'Đã có lỗi xảy ra, vui lòng thử lại!')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }

  const showConfirmApproval = type => {
    confirm({
      title: `Bạn có muốn ${
        type === PROPOSAL_STATUS.APPROVAL ? 'duyệt' : 'hủy'
      } thông tin này không?`,
      icon:
        type === PROPOSAL_STATUS.APPROVAL ? (
          <CheckOutlined
            style={{ color: blue }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        ) : (
          <StopOutlined
            style={{
              color: 'red',
            }}
            onPointerEnterCapture={undefined}
            onPointerLeaveCapture={undefined}
          />
        ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: type === PROPOSAL_STATUS.APPROVAL ? 'primary' : 'danger',
      onOk() {
        handleApprovalProposal({
          proposalCode: proposalId,
          type: type,
        }).then(() => Promise.resolve())
      },
    })
  }

  const showConfirmDelete = () => {
    confirm({
      title: 'Bạn có muốn xóa thông tin này không?',
      icon: (
        <QuestionCircleOutlined
          style={{ color: 'red' }}
          onPointerEnterCapture={undefined}
          onPointerLeaveCapture={undefined}
        />
      ),
      okText: 'Đồng ý',
      cancelText: 'Không',
      okType: 'danger',
      onOk() {
        handleDeleteProposal()
      },
    })
  }

  useEffect(() => {
    ;(async () => {
      loadingAnimationStore.showSpinner(true)
      await getDistributionVotesDetail(match?.params?.proposalId)
      await loadManagerInventoryList()
    })()
  }, [])

  useEffect(() => {
    const selectedData = managementAssetWarehouseAllLists?.filter(item => {
      return distributionVotesDetails?.proposal_asset_details.some(
        dataItem => dataItem.asset_id === item.id
      )
    })
    const selectedDataWithTitle = selectedData.map(item => {
      const foundDetail = distributionVotesDetails.proposal_asset_details.find(
        detail => detail.asset_id === item.id
      )
      if (foundDetail) {
        return {
          ...item,
          amount: foundDetail.amount,
          purpose: foundDetail.purpose,
        }
      } else {
        return {
          ...item,
          amount: foundDetail.amount,
          purpose: '',
        }
      }
    })
    setSelectedData(selectedDataWithTitle)
  }, [managementAssetWarehouseAllLists, distributionVotesDetails])

  // get detail
  const getDistributionVotesDetail = async id => {
    try {
      await DistributionVotesStore.clearDistributionVotesDetail()
      await DistributionVotesStore.getDistributionVotesDetail(id)
      await DistributionVotesStore.getDistributionVotesAllDetail(id)
    } catch (error) {
      console.log(error)
      message.error(error.vi || 'Đã có lỗi xảy ra, vui lòng thử lại!')
      history.push('/distribution-votes')
    } finally {
      loadingAnimationStore.showSpinner(false)
    }
  }
  // get check
  const loadManagerInventoryList = async () => {
    try {
      await managementAssetWarehouseStore.getManagementAssetWarehousetLists()
      await managementAssetWarehouseStore.getManagementAssetWarehouseAllList()
    } finally {
    }
  }

  useEffect(() => {
    return () => {
      notificationStore.clearNotificationType()
      DistributionVotesStore.clearOtherCommentList()
    }
  }, [])

  const handleCancelUpdateModal = () => {
    setIsVisibleUpdateModal(false)
  }

  const handleOpenUpdateModal = () => {
    setIsVisibleUpdateModal(true)
  }
  const handleCancelUpdateFollowersModal = () => {
    setIsVisibleUpdateFollowersModalModal(false)
    proposalStore.clearFormProposalType()
  }
  const handleOpenUpdateFollowersModal = () => {
    setIsVisibleUpdateFollowersModalModal(true)
  }

  const checkShowHandleDocument = () => {
    return (
      (distributionVotesDetail.proposal_status === PROPOSAL_STATUS.PENDING &&
        distributionVotesDetail?.has_no_config_approval_levels) ||
      (distributionVotesDetail &&
        !distributionVotesDetail?.has_no_config_approval_levels)
    )
  }

  const checkAccessControlUpdateAction = () => {
    return (
      authenticationStore.currentUser?.username ===
      otherDetail.create_user?.user_name
    )
  }
  const checkAccessControlUpdateActionV2 = () => {
    return otherDetail?.approval_levels?.some(
      item => item.username === authenticationStore.currentUser?.username
    )
  }
  const checkHasNoArppovedLevel = () => {
    if (otherDetail.has_no_config_approval_levels) return true

    if (otherDetail.approval_levels)
      return otherDetail.approval_levels
        .slice(1)
        .every(level => level.status !== 'APPROVED')
  }

  const menuHandleDocument = (
    <Menu>
      {distributionVotesDetail.proposal_status === PROPOSAL_STATUS.PENDING &&
        distributionVotesDetail?.has_no_config_approval_levels && (
          <>
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.approve__PROPOSAL__ASSET
            ) && (
              <Menu.Item
                onClick={() => showConfirmApproval(PROPOSAL_STATUS.APPROVAL)}
                icon={<UnreadOutlineIcon style={{ width: 16, height: 16 }} />}>
                Duyệt phiếu
              </Menu.Item>
            )}
            {aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.approve__PROPOSAL__ASSET
            ) && (
              <Menu.Item
                onClick={() => showConfirmApproval(PROPOSAL_STATUS.REJECT)}
                style={{
                  color: 'red',
                }}
                icon={
                  <ForbiddenCircleOutlineIcon
                    style={{ width: 16, height: 16 }}
                  />
                }>
                Từ chối
              </Menu.Item>
            )}
          </>
        )}

      {distributionVotesDetail &&
        (aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.edit__PROPOSAL__ASSET
        ) ||
          isAccountAdmin ||
          checkAccessControlUpdateAction()) && (
          <>
            <Menu.Item
              onClick={handleOpenUpdateModal}
              icon={<PenOutlineIcon style={{ width: 16, height: 16 }} />}>
              Chỉnh sửa
            </Menu.Item>
          </>
        )}
      {distributionVotesDetail &&
        (aclStore.checkAccessControlAction(
          ACL_ACTION_TYPE.delete__PROPOSAL__ASSET
        ) ||
          isAccountAdmin ||
          checkAccessControlUpdateAction()) && (
          <Menu.Item
            danger
            onClick={showConfirmDelete}
            icon={<TrashBin2OutlineIcon style={{ width: 16, height: 16 }} />}>
            Xóa
          </Menu.Item>
        )}
    </Menu>
  )

  const [proposalTypes, setProposalTypes] = useState([])
  useEffect(() => {
    const fetchData = async () => {
      const response = await proposalTypeStore.getAllProposalTypes()
      setProposalTypes(response.data)
    }
    fetchData()
  }, [])
  const renderTitlePage = useMemo(() => {
    for (const [value] of Object.entries(PROPOSAL_TYPE)) {
      if (otherDetail.proposal_type === value) {
        return PROPOSAL_TYPE[value].label
      }
    }
    const foundItem = proposalTypes.find(
      item => item.id == otherDetail.proposal_type
    )
    if (foundItem) {
      return foundItem.name
    }
  }, [otherDetail, proposalTypes])

  const renderAttachmentList = useCallback(() => {
    return otherDetail.attachments?.map(item => {
      return (
        <FileItem
          key={item.file_id}
          file_id={item.file_id}
          file_name={item.file_name}
          file_type={utils.getExtensionFile(item.file_name)}
        />
      )
    })
  }, [commonStore.appTheme, otherDetail])

  const [workingDaysList, setWorkingDaysList] = useState([])

  useEffect(() => {
    setWorkingDaysList(otherDetail?.proposalTimeList || [])
  }, [otherDetail?.proposalTimeList])

  const numberOfColumns =
    otherDetail?.proposal_type !== 'BUSINESS_TRIP' &&
    otherDetail?.proposal_type !== 'OVERTIME_NORMAL'
      ? 4
      : 3
  const columnWidth = `${100 / numberOfColumns}%`

  const tableColumns = [
    {
      title: 'Tên văn phòng phẩm',
      render: record => {
        const foundItem = managementAssetWarehouseAllLists.find(
          item => item.id === record.id
        )
        const isHighlighted =
          foundItem?.amount < record.amount &&
          distributionVotesDetails.proposal_status === PROPOSAL_STATUS.PENDING
        return (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              fontWeight: `${isHighlighted ? 'bold' : 'normal'}`,
              color: `${isHighlighted ? 'red' : 'black'}`,
            }}>
            {record.assetName}
          </div>
        )
      },
      width: 40,
    },
    // {
    //   title: 'Đặc tính',
    //   align: 'center',
    //   render: record => (
    //     <div
    //       style={{
    //         display: 'flex',
    //         alignItems: 'center',
    //         justifyContent: 'center',
    //       }}>
    //       {record?.property}
    //     </div>
    //   ),
    //   width: 10,
    // },
    {
      title: 'Đơn vị tính',
      align: 'center',
      render: record => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {record?.assetUnitName}
        </div>
      ),
      width: 10,
    },
    {
      title: 'Số lượng đề nghị',
      align: 'center',
      render: record => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {record?.amount}
        </div>
      ),
      width: 20,
    },
    {
      title: 'Mục đích sử dụng',
      align: 'center',
      render: record => (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}>
          {record?.purpose}
        </div>
      ),
      width: 30,
    },
  ]

  const sortDataTable = data => {
    return data.sort((a, b) => {
      let nameA = a.assetName.toLowerCase()
      let nameB = b.assetName.toLowerCase()
      if (nameA < nameB) return -1
      if (nameA > nameB) return 1
      return 0
    })
  }

  return (
    <DashboardLayout>
      <Helmet>
        <title>
          Chi tiết Phiếu phân phát văn phòng phẩm | Phiếu phân phát văn phòng
          phẩm
        </title>
      </Helmet>

      <AppPageHeader
        title={
          <>
            {distributionVotesDetail?.title}
            {distributionVotesDetail?.approval_levels?.length
              ? StatusTag(
                  TYPE_STATUS.PROPOSAL_ASSEST,
                  distributionVotesDetail.proposal_status
                )
              : ''}
          </>
        }
        showBackButton
        addon={
          !(
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.edit__PROPOSAL__ASSET
            ) ||
            isAccountAdmin ||
            checkAccessControlUpdateAction()
          ) &&
          !(
            aclStore.checkAccessControlAction(
              ACL_ACTION_TYPE.delete__PROPOSAL__ASSET
            ) ||
            isAccountAdmin ||
            checkAccessControlUpdateAction()
          ) ? (
            <></>
          ) : checkShowHandleDocument() ? (
            <Dropdown overlay={menuHandleDocument} trigger={['click']}>
              <Button
                style={{ width: 40, height: 40, flexShrink: 0 }}
                icon={
                  <MenuDotsBoldIcon
                    style={{
                      width: 20,
                      height: 20,
                      transform: 'rotate(90deg)',
                    }}
                  />
                }
                className="custom-ant-button icon-btn"
                type="default"
              />
            </Dropdown>
          ) : (
            <></>
          )
        }
      />

      <ViewDetailContent>
        <ContentWrapper>
          <BlockLeft>
            <div className="custom-create-page-content-wrapper">
              <h3 style={{ marginBottom: 20, fontSize: 18, fontWeight: 600 }}>
                Thông tin chung
              </h3>
              <Row gutter={[20, 20]}>
                <Col span={24}>
                  <KeyValueItem
                    label="Nội dung"
                    value={distributionVotesDetail?.title}
                  />
                </Col>
                <Col span={12}>
                  <AccessControlAction
                    aclActionType={ACL_ACTION_TYPE.col__phong_ban_ASSET}>
                    <KeyValueItem
                      label="Phòng ban"
                      value={
                        distributionVotesDetail.department_code ? (
                          distributionVotesDetail.department_code
                        ) : (
                          <EmptyText>Không có phòng ban.</EmptyText>
                        )
                      }
                    />
                  </AccessControlAction>
                </Col>
                <Col span={12}>
                  <KeyValueItem
                    label="Người theo dõi"
                    value={
                      distributionVotesDetail.followers &&
                      distributionVotesDetail.followers.length > 0 ? (
                        <PopoverWatchTime
                          userList={distributionVotesDetail.followers.map(
                            item => {
                              return {
                                full_name: item.name_lowercase,
                                id: item.user_name,
                                assignee_type: 'USER',
                                last_date_read: item.last_date_read,
                              }
                            }
                          )}
                          title={'Danh sách người theo dõi'}
                        />
                      ) : (
                        <EmptyText>Không có người theo dõi.</EmptyText>
                      )
                    }
                  />
                </Col>
                <Col span={24}>
                  <div>
                    <p
                      style={{
                        marginTop: '15px',
                        marginBottom: '15px',
                        fontWeight: '800',
                      }}>
                      Danh sách văn phòng phẩm :
                    </p>
                    <AppTable
                      size="small"
                      rowKey={record => record.code}
                      // dataSource={managerInventoryStore.managerInventoryList}
                      dataSource={sortDataTable(selectedData)}
                      columns={tableColumns}
                      pagination={false}
                      locale={{
                        emptyText: (
                          <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description={'Không có dữ liệu'}
                          />
                        ),
                      }}
                    />
                  </div>
                </Col>
              </Row>
            </div>
          </BlockLeft>
          <BlockRight>
            {distributionVotesDetail &&
            !distributionVotesDetail?.has_no_config_approval_levels &&
            distributionVotesDetail?.approval_levels?.length > 0 ? (
              <>
                <DistributionVotesAction
                  isAllAssetSelected={isAllAssetSelected()}
                  getDiffAssets={getDiffAssets()}
                  selectedData={selectedData}
                  listDataHistory={listDataHistory}
                  department_code={distributionVotesDetail.department_code}
                  create_user={distributionVotesDetail?.create_user?.user_name}
                />
                <div style={{ marginBottom: 20 }} />
              </>
            ) : null}

            <div className="custom-create-page-content-wrapper">
              <Tabs defaultActiveKey="1">
                <Tabs.TabPane tab="Ý kiến" key="1">
                  <DistributionVotesComment proposalId={proposalId} />
                  <SpinnerInlineComponent sizeSpin={'small'} />
                </Tabs.TabPane>
              </Tabs>
            </div>
          </BlockRight>
        </ContentWrapper>
      </ViewDetailContent>

      <Modal
        title={'Chỉnh sửa'}
        onCancel={handleCancelUpdateModal}
        width={1000}
        footer={null}
        maskClosable={false}
        visible={isVisibleUpdateModal}
        destroyOnClose
        wrapClassName="custom-modal-wrapper"
        style={{ top: 20 }}>
        {isVisibleUpdateModal && (
          <DistributionVotesUpdate
            onCancel={handleCancelUpdateModal}
            templateId={proposalId}
            btn="Cập nhật"
            check={true}
          />
        )}
      </Modal>
    </DashboardLayout>
  )
}

DistributionVotesDetailPage.propTypes = {}

export default inject(
  'managementAssetWarehouseStore',
  'DistributionVotesStore',
  'proposalStore',
  'notificationStore',
  'aclStore',
  'commonStore',
  'authenticationStore',
  'proposalTypeStore',
  'loadingAnimationStore',
  'selectPeopleStore'
)(observer(DistributionVotesDetailPage))
